import {OreEntity} from "./config/OreConfig";
import MineLandNode from "./MineLandNode";
import getOneBundle, {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../BundleResourceConfig";
import O1HD from "../../../../engines/gameEngine";
import {NormalBackpackI} from "../../manager/DefineInterface";
import {backPackEventMap} from "../../config/BackpackEventConfig";
import WeChatFrameByAuction from "../weChat/WeChaFrameByAuciton";
import NormalGameManager from "../../manager/NormalGameManager";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

/**
 * 挖矿成功
 */
@ccclass
export default class DigSuccessNode extends cc.Component {

    @property(cc.Sprite)
    oreBgSpirit : cc.Sprite = null;
    @property(cc.Sprite)
    oreSpirit : cc.Sprite = null;
    @property(cc.Sprite)
    oreNameSpirit : cc.Sprite = null;
    @property(cc.Label)
    oreNameLb : cc.Label = null;
    @property(cc.Label)
    descLb : cc.Label = null;
    @property(cc.Label)
    priceLb : cc.Label = null;
    @property(cc.Node)
    videoRedNode : cc.Node = null;
    @property(cc.Node)
    btnSale : cc.Node = null;

    private mOreEntity : OreEntity;
    private mParentScript : MineLandNode;
    private mGoodsEntity : NormalBackpackI;

    onLoad () {}

    start () {

    }

    /**
     * 绑定数据
     * @param oreEntity
     */
    async bindData( oreEntity : OreEntity , parentScript : MineLandNode ){
        this.mOreEntity = oreEntity;
        this.mParentScript = parentScript;
        this.mGoodsEntity = backPackEventMap()[this.mOreEntity.goodsId];
        let oreDescPath : string;
        let oreBgPath : string;
        switch ( this.mOreEntity.level ) {
            case 1:
                oreDescPath = "初级矿石";
                oreBgPath = "初级光效";
                break;
            case 2:
                oreDescPath = "中级矿石";
                oreBgPath = "中级光效";
                break;
            case 3:
                oreDescPath = "高级矿石";
                oreBgPath = "高级光效";
                break;
            case 4:
                oreDescPath = "天价矿石";
                oreBgPath = "高级光效";
                break;
        }
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.mineLandGameBundle );
        //加载矿石描述
        bundle.load(`assets/${oreDescPath}` , cc.SpriteFrame,(error,assets:cc.SpriteFrame)=>{
            if ( error ) {
                return;
            }
            this.oreNameSpirit.spriteFrame = assets;
        });
        //加载矿石背景
        bundle.load(`assets/${oreBgPath}` , cc.SpriteFrame,(error,assets:cc.SpriteFrame)=>{
            if ( error ) {
                return;
            }
            this.oreBgSpirit.spriteFrame = assets;
        });
        //加载矿石本身
        bundle.load(`assets/ore/${this.mOreEntity.imgPath}` , cc.SpriteFrame,(error,assets:cc.SpriteFrame)=>{
            if ( error ) {
                console.error(`矿石加载错误${this.mOreEntity.imgPath}`)
                return;
            }
            this.oreSpirit.spriteFrame = assets;
        });

        this.descLb.string = `${this.mOreEntity.simpleDesc}`;
        this.oreNameLb.string = this.mOreEntity.name;
        this.priceLb.string = `${Math.floor( NormalGameManager._instance.getPriceRate() * this.mGoodsEntity.sellPrice )}`;

        if ( this.mOreEntity.level == 3 || this.mOreEntity.level == 4 ) {
            this.btnSale.active = true;
        }
    }

    /**
     * 放弃
     */
    onBtnGiveUp(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 获取
     */
    onBtnGet(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.mParentScript.mCurrPackageCount >= this.mParentScript.mCanUsePackageCount ) {
            this.mParentScript.openEnlargeCapacity();
            return;
        }
        this.mParentScript.incomeBackpack( this.mOreEntity.goodsId );
        this.node.removeFromParent();
        this.node.destroy();
    }

    private salePeopleFlag : boolean = true;
    /**
     * 卖给大佬
     */
    onBtnSale(){
        if ( !this.salePeopleFlag ) {
            return;
        }

        this.salePeopleFlag = false;
        if ( this.videoRedNode.active ) {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.openDLPrefab().then();
            },()=>{O1HD.getModules().uiControlModule.showMessageBox("")},()=>{},"矿石-卖给大佬");
        }else{
            this.openDLPrefab().then();
        }
    }


    //打开某个预制体
    async openDLPrefab( ){
        let prefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.WeChatGameBundle , "weChat/prefab/WeChatFrameByAuction" );
        if ( prefab ){
            let node : cc.Node = cc.instantiate(prefab);
            let nBase = node.getComponent( WeChatFrameByAuction );
            if( nBase ){
                nBase.bindData( this.mOreEntity.name ,this.mGoodsEntity.sellPrice , ( sellFlag ) =>{
                    if ( sellFlag ) {
                        this.node.removeFromParent();
                        this.node.destroy();
                    }else{
                        // 添加广告标识
                        this.videoRedNode.active = true;
                    }
                    this.salePeopleFlag = true;
                } );
                node.group = "UI";
                this.mParentScript.node.addChild( node );
            }else{
                console.error("openDLPrefab 打开失败");
            }
        }else{
            this.salePeopleFlag = true;
            O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        }
    }
}

